import moment from 'moment'

import { CARDS } from '../reducers'
import { disabledCardsSelector, waitingListPendingSelector, waitingListNextAvailableDateSelector } from '../selectors'
import { enableCard, lastBookingRedeemPromoCode, lastBookingRemovePromoCode, lastBookingSetAutoRenew } from '../actions'
import { DATE_FORMAT } from 'shared/constants'
import { withRouter, withTranslate } from 'i18n/utils'
import { DatePicker } from 'shared/components/TimePicker'

import { getSeasonTickets, validateWaitingListKey } from 'grs/actions'
import {
    seasonTicketsSelector,
    selectedSeasonTicketSelector,
    selectedTicketRatePendingSelector,
    seasonTicketsPendingSelector,
    promoCodeBarcodeSelector,
    lastBookingBasketItemSelector,
    rawPromoCodeSelector,
    waitingListKeySelector,
    lastBookingDetailsSelector,
} from '../selectors'
import { userSelector } from 'auth/selectors'
import { makePurchasePendingSelector, numberOfItemsSelector } from 'basket/selectors'
import { CardSection } from '@components/CardSection'
import { selectSeasonTicket, setRawPromoCode } from '../actions'
import { pendingSelector } from 'api/selectors'
import { PromoCode } from './PromoCode'
import RateList from './RateList/RateList'
import ErrorMessage from '@components/ErrorMessage'
import Checkbox from '@components/Checkbox'

const MonthlySelection = ({
    grsId,
    enableCard,
    disabledCards,
    getSeasonTickets,
    seasonTickets,
    seasonTicketsPending,
    selectSeasonTicket,
    selectedSeasonTicket,
    selectedTicketRatePending,
    promoCodeBarcode,
    promoCodePending,
    lastBookingRedeemPromoCode,
    lastBookingRemovePromoCode,
    numberOfItemsInBasket,
    makePurchasePending,
    lastBookingBasketItem,
    rawPromoCode,
    setRawPromoCode,
    location,
    validateWaitingListKey,
    waitingListPending,
    user,
    waitingListKey,
    waitingListNextAvailableDate,
    lastBookingSetAutoRenew,
    lastBookingDetails,
    translate: t,
}) => {
    const rateListLoading = seasonTicketsPending === true || waitingListPending === true
    const isOnWaitingList =
        selectedSeasonTicket.ticket && selectedSeasonTicket.ticket.isOnWaitingList && !waitingListKey
    const selectedSeasonTicketId =
        (selectedSeasonTicket.ticket && selectedSeasonTicket.ticket.id) || location.query.rateId

    const currentItemIndex = numberOfItemsInBasket + 1
    const isPromoCodePending = promoCodePending[`redeemPromoCode${currentItemIndex}`]
    const promoCodeError = isPromoCodePending instanceof Error ? isPromoCodePending.message : ''
    const onSelectTicket = ticket => {
        if (selectedSeasonTicketId !== ticket.id) {
            selectSeasonTicket(ticket, grsId)
        }
        enableCard([CARDS.CONFIRM_VEHICLE, CARDS.SELECT_PARKING_TIME])
    }
    const promoCodeDiscount =
        lastBookingBasketItem && lastBookingBasketItem.promoCode && !isPromoCodePending
            ? lastBookingBasketItem.promoCode.promoDiscount
            : null

    const discountedRateId =
        lastBookingBasketItem && lastBookingBasketItem.rate && lastBookingBasketItem.promoCode
            ? lastBookingBasketItem.rate.rateId
            : null

    const onAddPromoCode = promoCodeValue => {
        lastBookingRedeemPromoCode(
            {
                id: currentItemIndex,
                rate: { ...selectedSeasonTicket.rate, waitingListKey },
            },
            promoCodeValue
        )
    }

    const onStartDateChange = date => {
        selectSeasonTicket(selectedSeasonTicket.ticket, grsId, date, waitingListKey)
    }

    const isOutSideRange = day => {
        if (waitingListKey) {
            return day.isBefore(moment(waitingListNextAvailableDate), 'day')
        } else {
            return day.isBefore(moment(selectedSeasonTicket.ticket.nextAvailableDateISO), 'day')
        }
    }

    const setAutoRenew = (event, preset = null) => {
        const value = event !== null ? event.target.checked : preset
        lastBookingSetAutoRenew(value)
    }

    React.useEffect(() => {
        if (promoCodeBarcode) {
            setAutoRenew(null, false)
        }
    }, [promoCodeBarcode])

    React.useEffect(() => {
        if (promoCodeBarcode) {
            lastBookingRedeemPromoCode(
                {
                    id: currentItemIndex,
                    rate: { ...selectedSeasonTicket.rate, waitingListKey },
                },
                promoCodeBarcode
            )
        }
    }, [selectedSeasonTicket.rate])

    React.useEffect(() => {
        getSeasonTickets(grsId)
    }, [])

    React.useEffect(() => {
        const key = location.query.waitingListKey
        if (user && key && waitingListPending !== true) {
            validateWaitingListKey(key)
            return
        }
    }, [user, location.query.waitingListKey])

    return (
        <>
            {seasonTicketsPending !== true && seasonTickets.length === 0 && (
                <ErrorMessage messages={[t('booking.error.rates.not.found')]} />
            )}
            <CardSection title={<T>booking.monthly.title.select-products</T>} loading={rateListLoading}>
                {waitingListKey && selectedSeasonTicket.rate ? (
                    <RateList
                        rates={[selectedSeasonTicket.rate]}
                        selectedRateId={selectedSeasonTicketId}
                        discountedRateId={discountedRateId}
                        promoCodeDiscount={promoCodeDiscount}
                        selectRate={() => null}
                        disabled={false}
                        waitingList={true}
                    />
                ) : (
                    <RateList
                        rates={seasonTickets}
                        selectedRateId={selectedSeasonTicketId}
                        discountedRateId={discountedRateId}
                        promoCodeDiscount={promoCodeDiscount}
                        selectRate={onSelectTicket}
                        disabled={
                            (seasonTicketsPending && !(seasonTicketsPending instanceof Error)) ||
                            makePurchasePending === true
                        }
                    />
                )}

                {!isOnWaitingList && (
                    <div className="d-inline-flex mt-4 p-0">
                        <PromoCode
                            promoCodeValue={rawPromoCode}
                            setRawPromoCode={setRawPromoCode}
                            onRemovePromoCode={lastBookingRemovePromoCode}
                            onAddPromoCode={onAddPromoCode}
                            label={<T>booking.promocode.title</T>}
                            removePromoCodeLabel={<T>booking.promocode.remove</T>}
                            btnLabel={<T>booking.promocode.add</T>}
                            placeholder={<T>booking.promocode.placeholder</T>}
                            error={promoCodeError}
                            success={!!promoCodeBarcode}
                            disabled={
                                !selectedSeasonTicket.rate ||
                                (selectedTicketRatePending && !(selectedTicketRatePending instanceof Error)) ||
                                makePurchasePending === true
                            }
                            isLoading={isPromoCodePending === true}
                        />
                    </div>
                )}
            </CardSection>
            {!isOnWaitingList && (
                <CardSection
                    title={<T>booking.monthly.select-start-time</T>}
                    disabled={disabledCards[CARDS.SELECT_PARKING_TIME]}
                    loading={selectedTicketRatePending === true}>
                    <div className="row">
                        <div className="col-sm-4">
                            <DatePicker
                                disabled={makePurchasePending === true}
                                label={<T>label.parking.start</T>}
                                displayFormat={DATE_FORMAT}
                                onChange={onStartDateChange}
                                isOutsideRange={isOutSideRange}
                                value={
                                    selectedSeasonTicket.rate &&
                                    moment(new Date(selectedSeasonTicket.rate.fromDate), DATE_FORMAT)
                                }
                            />
                        </div>
                        <div className="col-sm-4">
                            <DatePicker
                                label={<T>label.parking.end</T>}
                                readOnly={true}
                                displayFormat={DATE_FORMAT}
                                value={
                                    selectedSeasonTicket.rate &&
                                    moment(new Date(selectedSeasonTicket.rate.toDate), DATE_FORMAT)
                                }
                            />
                        </div>
                        {selectedSeasonTicket.rate && selectedSeasonTicket.rate.promptAutoRenew && (
                            <div className="col-sm-4 d-flex align-items-center">
                                <Checkbox
                                    checked={
                                        lastBookingDetails && lastBookingDetails.autoRenew
                                            ? !!lastBookingDetails.autoRenew
                                            : false
                                    }
                                    disabled={!!promoCodeBarcode}
                                    onChange={setAutoRenew}
                                    className="m-0 mt-3">
                                    <T>
                                        {promoCodeBarcode
                                            ? `booking.monthly.auto-renew-disabled`
                                            : `booking.monthly.auto-renew-label`}
                                    </T>
                                </Checkbox>
                            </div>
                        )}
                    </div>
                </CardSection>
            )}
        </>
    )
}

export default compose(
    withRouter,
    withTranslate,
    connect(
        createStructuredSelector({
            disabledCards: disabledCardsSelector,
            seasonTickets: seasonTicketsSelector,
            selectedSeasonTicket: selectedSeasonTicketSelector,
            selectedTicketRatePending: selectedTicketRatePendingSelector,
            seasonTicketsPending: seasonTicketsPendingSelector,
            makePurchasePending: makePurchasePendingSelector,
            promoCodeBarcode: promoCodeBarcodeSelector,
            promoCodePending: pendingSelector,
            numberOfItemsInBasket: numberOfItemsSelector,
            lastBookingBasketItem: lastBookingBasketItemSelector,
            rawPromoCode: rawPromoCodeSelector,
            user: userSelector,
            waitingListKey: waitingListKeySelector,
            waitingListPending: waitingListPendingSelector,
            waitingListNextAvailableDate: waitingListNextAvailableDateSelector,
            lastBookingDetails: lastBookingDetailsSelector,
        }),
        {
            enableCard,
            getSeasonTickets,
            selectSeasonTicket,
            lastBookingRemovePromoCode,
            lastBookingRedeemPromoCode,
            setRawPromoCode,
            validateWaitingListKey,
            lastBookingSetAutoRenew,
        }
    )
)(MonthlySelection)
